<template>
  <AuthProviderWithModal
    :auth-provider-type="authProviderType"
    :auth-provider="authProvider"
    :in-error="inError"
    @delete="$emit('delete')"
    @hidden="checkValidity()"
  >
    <OpenIdConnectSettingsForm
      v-bind="$attrs"
      ref="form"
      :auth-provider="authProvider"
      :auth-provider-type="authProviderType"
      :auth-providers="authProviders"
      :default-values="defaultValues"
      :disabled="disabled"
      @values-changed="onValuesChanged"
    >
      <template #config>
        <FormGroup
          small-label
          :label="$t('commonOidcSettingForm.callbackTitle')"
          required
          :helper-text="$t('commonOidcSettingForm.callbackHelperText')"
        >
          <div class="common-oidc-setting-form__url-block">
            <div
              v-for="callback in callbacks"
              :key="callback.name"
              class="common-oidc-setting-form__url"
            >
              <span class="common-oidc-setting-form__url-domain">
                {{ callback.name }}
              </span>
              <span
                class="common-oidc-setting-form__url-dest"
                :title="callback.url"
                @click.prevent="
                  ;[copyToClipboard(callback.url), $refs.copiedACS.show()]
                "
              >
                {{ callback.previewUrl }}
              </span>
            </div>
            <Copied ref="copiedACS"></Copied>
          </div>
        </FormGroup>
      </template>
    </OpenIdConnectSettingsForm>
  </AuthProviderWithModal>
</template>

<script>
import OpenIdConnectSettingsForm from '@grouper_enterprise/components/admin/forms/OpenIdConnectSettingsForm.vue'
import authProviderForm from '@grouper/modules/core/mixins/authProviderForm'
import AuthProviderWithModal from '@grouper/modules/builder/components/userSource/AuthProviderWithModal'
import { mapGetters } from 'vuex'
import { copyToClipboard } from '@grouper/modules/database/utils/clipboard'

export default {
  name: 'CommonOIDCSettingsForm',
  emits: ['delete', 'values-changed'],
  components: { OpenIdConnectSettingsForm, AuthProviderWithModal },
  mixins: [authProviderForm],
  props: {
    integration: {
      type: Object,
      required: true,
    },
    userSource: {
      type: Object,
      required: true,
    },
  },
  data() {
    return { inError: false, values: {} }
  },
  computed: {
    ...mapGetters({ domains: 'domain/getDomains' }),
    callbacks() {
      const userSourceType = this.$registry.get(
        'userSource',
        this.userSource.type
      )

      const userSourceUid = userSourceType.genUid(this.userSource)

      const url = `${this.$config.public.publicBackendUrl}/api/user-source/${userSourceUid}/sso/oauth2/openid_connect/callback/`
      const previewUrl = `${this.$config.public.publicBackendUrl.substr(
        0,
        10
      )}.../user-source/${userSourceUid}/sso/...`

      const preview = [
        {
          name: this.$t('commonOidcSettingForm.preview'),
          url,
          previewUrl,
        },
      ]

      const others = this.domains.map((domain) => ({
        name: domain.domain_name,
        url: `${this.$config.public.publicBackendUrl}/api/user-source/domain_${domain.id}__${userSourceUid}/sso/oauth2/openid_connect/callback/`,
        previewUrl: `${this.$config.public.publicBackendUrl.substr(
          0,
          10
        )}.../user-source/domain_${domain.id}__${userSourceUid}/sso/...`,
      }))

      return [...preview, ...others]
    },
  },
  watch: {
    'v$.$anyDirty'() {
      this.checkValidity()
    },
  },
  methods: {
    copyToClipboard,
    onValuesChanged(values) {
      this.checkValidity()
      this.$emit('values-changed', values)
    },
    checkValidity() {
      if (
        this.$refs.form &&
        !this.$refs.form.isFormValid() &&
        this.$refs.form.v$.$anyDirty
      ) {
        this.inError = true
      } else {
        this.inError = false
      }
    },
    handleServerError(error) {
      if (this.$refs.form.handleServerError(error)) {
        this.inError = true
        return true
      }
      return false
    },
  },
  validations() {
    return {}
  },
}
</script>
